import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'font-awesome/css/font-awesome.css';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import common_de from './translations/de.json';
import common_en from './translations/en.json';
import common_fr from './translations/fr.json';
import common_es from './translations/es.json';
import common_fi from './translations/fl.json';
import common_ro from './translations/ro.json';
import common_it from './translations/it.json';
import common_nl from './translations/nl.json';
import common_sv from './translations/sv.json';
import common_pt from './translations/pt.json';
import common_ru from './translations/ru.json';
import common_uk from './translations/uk.json';

i18next.init({
    lng: 'en',
    debug: false,
    resources: {
        en: {
            common: common_en
        },
        de: {
            common: common_de
        },
        fr: {
            common: common_fr
        },
        es: {
            common: common_es
        },
        fil: {
            common: common_fi
        },
        it: {
            common: common_it
        },
        nl: {
            common: common_nl
        },
        pt: {
            common: common_pt
        },
        ro: {
            common: common_ro
        },
        ru: {
            common: common_ru
        },
        sv: {
            common: common_sv
        },
        uk: {
            common: common_uk
        },
    }
}, function (err, t) {
    // init set content
    // this.updateContent();
    // document.getElementById('output').innerHTML = i18next.t('key');
});
ReactDOM.render(
    <I18nextProvider i18n={i18next}>
        <App />
    </I18nextProvider>,
    document.getElementById('root')
);
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js